import React, { useState, useEffect }  from 'react';
import axios from 'axios';
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
//import FormControl from 'react-bootstrap/FormControl';
//import InputGroup from 'react-bootstrap/InputGroup';
//import FormCheckInput from 'react-bootstrap/esm/FormCheckInput';
//import FormCheckLabel from 'react-bootstrap/esm/FormCheckLabel';
//import InputGroup from 'react-bootstrap/InputGroup';
import Row from 'react-bootstrap/Row';
//import imgSrcMAC from './img/LOGOTIPO_HOSPITALES_MAC_1.png';
//import imgSrc4 from './img/nav_bar.jpeg';
import Container from 'react-bootstrap/esm/Container';
//import Card from 'react-bootstrap/Card';
//import { alignPropType } from 'react-bootstrap/esm/types';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
//
import Table from 'react-bootstrap/Table'
//
import { startOfWeek, endOfWeek, format } from 'date-fns';
//
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
//
const RegistroHoras = ({usuario, apiUrl}) => {
    const [selectedProyecto, setSelectedProyecto] = useState();
    const [nombreProyectoSelected, setNombreProyectoSelected] = useState();
    const [nombreTareaSelected, setNombreTareaSelected] = useState();
    //
    const [selectedEtapa, setSelectedEtapa] = useState();
    const [selectedTarea, setSelectedTarea] = useState();
    const [confirm, setConfirm] = useState(false);
    const [totalHorasPorSemana, setTotalHorasPorSemana] = useState();
    const [totalHorasPorDia, setTotalHorasPorDia] = useState();
    // Arreglos para los select
    const [proyectos, setProyectos] = useState([]);
    const [etapas, setEtapas] = useState([]);
    const [tareas, setTareas] = useState([]);
    const [diasAsueto, setDiasAsueto] = useState([]);
    //
    const dateFechaActual = new Date();
    dateFechaActual.setHours(0, 0, 0, 0);
    const [selectedDate, setSelectedDate] = useState(dateFechaActual);
    const [fechaInicioProyecto, setFechaInicioProyecto] = useState(dateFechaActual);
    const [fechaFinProyecto, setFechaFinProyecto] = useState(dateFechaActual);
    // Variables de horas, fechas, actividades y estados de aprobación por hora
    const [diaAsuetoLunes, setDiaAsuetoLunes] = useState(false);
    const [diaAsuetoMartes, setDiaAsuetoMartes] = useState(false);
    const [diaAsuetoMiercoles, setDiaAsuetoMiercoles] = useState(false);
    const [diaAsuetoJueves, setDiaAsuetoJueves] = useState(false);
    const [diaAsuetoViernes, setDiaAsuetoViernes] = useState(false);
    const [diaAsuetoSabado, setDiaAsuetoSabado] = useState(false);
    const [diaAsuetoDomingo, setDiaAsuetoDomingo] = useState(false);
    //
    const [observacionesLunes, setObservacionesLunes] = useState();
    const [observacionesMartes, setObservacionesMartes] = useState();
    const [observacionesMiercoles, setObservacionesMiercoles] = useState();
    const [observacionesJueves, setObservacionesJueves] = useState();
    const [observacionesViernes, setObservacionesViernes] = useState();
    const [observacionesSabado, setObservacionesSabado] = useState();
    const [observacionesDomingo, setObservacionesDomingo] = useState();
    //
    const [estatusDateLunes, setEstatusDateLunes] = useState("PENDIENTE");
    const [estatusDateMartes, setEstatusDateMartes] = useState("PENDIENTE");
    const [estatusDateMiercoles, setEstatusDateMiercoles] = useState("PENDIENTE");
    const [estatusDateJueves, setEstatusDateJueves] = useState("PENDIENTE");
    const [estatusDateViernes, setEstatusDateViernes] = useState("PENDIENTE");
    const [estatusDateSabado, setEstatusDateSabado] = useState("PENDIENTE");
    const [estatusDateDomingo, setEstatusDateDomingo] = useState("PENDIENTE");
    //
    const [idLunes, setIdLunes] = useState("-1");
    const [idMartes, setIdMartes] = useState("-1");
    const [idMiercoles, setIdMiercoles] = useState("-1");
    const [idJueves, setIdJueves] = useState("-1");
    const [idViernes, setIdViernes] = useState("-1");
    const [idSabado, setIdSabado] = useState("-1");
    const [idDomingo, setIdDomingo] = useState("-1");
    //
    var dateLunes;
    var dateMartes;
    var dateMiercoles;
    var dateJueves;
    var dateViernes;
    var dateSabado;
    var dateDomingo;
    //
    const [horasLunes, setHorasLunes] = useState(0);
    const [horasMartes, setHorasMartes] = useState(0);
    const [horasMiercoles, setHorasMiercoles] = useState(0);
    const [horasJueves, setHorasJueves] = useState(0);
    const [horasViernes, setHorasViernes] = useState(0);
    const [horasSabado, setHorasSabado] = useState(0);
    const [horasDomingo, setHorasDomingo] = useState(0);
    //
    const [actividadesLunes, setActividadesLunes] = useState();
    const [actividadesMartes, setActividadesMartes] = useState();
    const [actividadesMiercoles, setActividadesMiercoles] = useState();
    const [actividadesJueves, setActividadesJueves] = useState();
    const [actividadesViernes, setActividadesViernes] = useState();
    const [actividadesSabado, setActividadesSabado] = useState();
    const [actividadesDomingo, setActividadesDomingo] = useState();
    //
    const textCenter = {
        textAlign: 'center'
    }
    Date.prototype.addDays = function(days) {
        var date = new Date(this.valueOf());
        date.setDate(date.getDate() + days);
        return date;
    }

    const validacionInput = (event) => {
        // La tecla debe de ser carácter válido
        if (!/[0-9]/.test(event.key) && event.key !== 'Backspace' && event.key !== 'Tab') {
            event.preventDefault();
        }
    }

    const handleChangeHoras = (valor, dia) => {
        //*/
        if(valor.length > 2) 
        {
            switch(dia)
            {
                case 'lunes':
                    setHorasLunes(0)
                    break;
                case 'martes':
                    setHorasMartes(0)
                    break;
                case 'miercoles':
                    setHorasMiercoles(0)
                    break;
                case 'jueves':
                    setHorasJueves(0)
                    break;
                case 'viernes':
                    setHorasViernes(0)
                    break;
                case 'sabado':
                    setHorasSabado(0)
                    break;
                case 'domingo':
                    setHorasDomingo(0)
                    break;
            }
        }
        else
        {
            switch(dia)
            {
                case 'lunes':
                    setHorasLunes(valor)
                    break;
                case 'martes':
                    setHorasMartes(valor)
                    break;
                case 'miercoles':
                    setHorasMiercoles(valor)
                    break;
                case 'jueves':
                    setHorasJueves(valor)
                    break;
                case 'viernes':
                    setHorasViernes(valor)
                    break;
                case 'sabado':
                    setHorasSabado(valor)
                    break;
                case 'domingo':
                    setHorasDomingo(valor)
                    break;
            }
        }
    }
    const obtenHorasLaboradas = (fechas) => {
        axios.post(`${apiUrl}/horaslaboradas/obtenHorasColaborador?token=${sessionStorage.getItem('token')}`, 
            {
                idTarea: selectedTarea, 
                idUsuario: usuario.IDUSUARIO, 
                arrFechas: fechas,
            })
            .then((objResponse) => {
                if(objResponse.data.ok && objResponse.data.response.length > 0) {
                    // Lunes
                    if(objResponse.data.response[0]) {
                        setIdLunes(objResponse.data.response[0].IDHORA);
                        setHorasLunes(objResponse.data.response[0].HORAS);
                        setActividadesLunes((objResponse.data.response[0].ACTIVIDAD) === null ? "" : (objResponse.data.response[0].ACTIVIDAD));
                        setEstatusDateLunes(objResponse.data.response[0].ESTATUSSUPERVISOR)
                        setObservacionesLunes(objResponse.data.response[0].OBSERVACIONESSUPERVISOR);
                    }
                    // Martes
                    if(objResponse.data.response[1]) {
                        setIdMartes(objResponse.data.response[1].IDHORA);
                        setHorasMartes(objResponse.data.response[1].HORAS);
                        setActividadesMartes((objResponse.data.response[1].ACTIVIDAD) === null ? "" : (objResponse.data.response[1].ACTIVIDAD));
                        setEstatusDateMartes(objResponse.data.response[1].ESTATUSSUPERVISOR);
                        setObservacionesMartes(objResponse.data.response[1].OBSERVACIONESSUPERVISOR);
                    }
                    // Miercoles
                    if(objResponse.data.response[2]) {
                        setIdMiercoles(objResponse.data.response[2].IDHORA);
                        setHorasMiercoles(objResponse.data.response[2].HORAS);
                        setActividadesMiercoles((objResponse.data.response[2].ACTIVIDAD) === null ? "" : (objResponse.data.response[2].ACTIVIDAD));
                        setEstatusDateMiercoles(objResponse.data.response[2].ESTATUSSUPERVISOR);
                        setObservacionesMiercoles(objResponse.data.response[2].OBSERVACIONESSUPERVISOR);
                    }
                    // Jueves
                    if(objResponse.data.response[3]) {
                        setIdJueves(objResponse.data.response[3].IDHORA);
                        setHorasJueves(objResponse.data.response[3].HORAS);
                        setActividadesJueves((objResponse.data.response[3].ACTIVIDAD) === null ? "" : (objResponse.data.response[3].ACTIVIDAD));
                        setEstatusDateJueves(objResponse.data.response[3].ESTATUSSUPERVISOR);
                        setObservacionesJueves(objResponse.data.response[3].OBSERVACIONESSUPERVISOR);
                    }
                    // Viernes
                    if(objResponse.data.response[4]) {
                        setIdViernes(objResponse.data.response[4].IDHORA);
                        setHorasViernes(objResponse.data.response[4].HORAS);
                        setActividadesViernes((objResponse.data.response[4].ACTIVIDAD) === null ? "" : (objResponse.data.response[4].ACTIVIDAD));
                        setEstatusDateViernes(objResponse.data.response[4].ESTATUSSUPERVISOR);
                        setObservacionesViernes(objResponse.data.response[4].OBSERVACIONESSUPERVISOR);
                    }
                    // Sábado
                    if(objResponse.data.response[5]) {
                        setIdSabado(objResponse.data.response[5].IDHORA);
                        setHorasSabado(objResponse.data.response[5].HORAS);
                        setActividadesSabado((objResponse.data.response[5].ACTIVIDAD) === null ? "" : (objResponse.data.response[5].ACTIVIDAD));
                        setEstatusDateSabado(objResponse.data.response[5].ESTATUSSUPERVISOR);
                        setObservacionesSabado(objResponse.data.response[5].OBSERVACIONESSUPERVISOR);
                    }
                    // Domingo
                    if(objResponse.data.response[6]) {
                        setIdDomingo(objResponse.data.response[6].IDHORA);
                        setHorasDomingo(objResponse.data.response[6].HORAS);
                        setActividadesDomingo((objResponse.data.response[6].ACTIVIDAD) === null ? "" : (objResponse.data.response[6].ACTIVIDAD));
                        setEstatusDateDomingo(objResponse.data.response[6].ESTATUSSUPERVISOR);
                        setObservacionesDomingo(objResponse.data.response[6].OBSERVACIONESSUPERVISOR);
                    }
                }
                else if(objResponse.data.ok && objResponse.data.response.length === 0) {
                    
                }
                else {
                    alert("Ha ocurrido un error al recuperar las horas trabajadas.");
                }
            })
            .catch((error) => {
                alert('hubo un error al recuperar las horas laboradas: ' + error.response.data)
            });
    }
    // 
    const handleChangeFecha = (date) => {
        // Lunes
        setIdLunes("-1");
        setHorasLunes(0);
        setActividadesLunes("");
        setEstatusDateLunes("PENDIENTE")
        setObservacionesLunes("");
        // Martes
        setIdMartes("-1");
        setHorasMartes(0);
        setActividadesMartes("");
        setEstatusDateMartes("PENDIENTE")
        setObservacionesMartes("");
        // Miércoles 
        setIdMiercoles("-1");
        setHorasMiercoles(0);
        setActividadesMiercoles("");
        setEstatusDateMiercoles("PENDIENTE")
        setObservacionesMiercoles("");
        // Jueves
        setIdJueves("-1");
        setHorasJueves(0);
        setActividadesJueves("");
        setEstatusDateJueves("PENDIENTE")
        setObservacionesJueves("");
        // Viernes
        setIdViernes("-1");
        setHorasViernes(0);
        setActividadesViernes("");
        setEstatusDateViernes("PENDIENTE")
        setObservacionesViernes("");
        // Sábado
        setIdSabado("-1");
        setHorasSabado(0);
        setActividadesSabado("");
        setEstatusDateSabado("PENDIENTE")
        setObservacionesSabado("");
        // Domingo
        setIdDomingo("-1");
        setHorasDomingo(0);
        setActividadesDomingo("");
        setEstatusDateDomingo("PENDIENTE")
        setObservacionesDomingo("");
        //
        setSelectedDate(date);
        getWeekLabel(date);
        let tempFechas = {
            lunes: dateLunes,
            martes: dateMartes,
            miercoles: dateMiercoles,
            jueves: dateJueves,
            viernes: dateViernes,
            sabado: dateSabado,
            domingo: dateDomingo,
        }
        obtenDiasAsueto(tempFechas);
        obtenHorasLaboradas(tempFechas);
    };

    useEffect(() => {
        diasAsueto.map((asueto, index) => {
            const tempAsueto = asueto.fechaDiaAsueto.substring(5, 10);
            // Lunes
            if(tempAsueto === format(dateLunes,'MM-dd')) {
                setDiaAsuetoLunes(true);
                setActividadesLunes(asueto.diaAsuetoDes)
            }
            // Martes
            if(tempAsueto === format(dateMartes,'MM-dd')) {
                setDiaAsuetoMartes(true);
                setActividadesMartes(asueto.diaAsuetoDes)
            }
            // Miércoles
            if(tempAsueto === format(dateMiercoles,'MM-dd')) {
                setDiaAsuetoMiercoles(true);
                setActividadesMiercoles(asueto.diaAsuetoDes)
            }
            // Jueves
            if(tempAsueto === format(dateJueves,'MM-dd')) {
                setDiaAsuetoJueves(true);
                setActividadesJueves(asueto.diaAsuetoDes)
            }
            // Viernes
            if(tempAsueto === format(dateViernes,'MM-dd')) {
                setDiaAsuetoViernes(true);
                setActividadesViernes(asueto.diaAsuetoDes)
            }
            // Sábado
            if(tempAsueto === format(dateSabado,'MM-dd')) {
                setDiaAsuetoSabado(true);
                setActividadesSabado(asueto.diaAsuetoDes)
            }
            // Domingo
            if(tempAsueto === format(dateDomingo,'MM-dd')) {
                setDiaAsuetoDomingo(true);
                setActividadesDomingo(asueto.diaAsuetoDes)
            }
        })
    }, [diasAsueto])

    const limpiarFiltros = () => {
        setSelectedProyecto(null);
        setProyectos([]);
        obtenerProyectos();
        setSelectedEtapa(null);
        setEtapas([]);
        setSelectedTarea(null);
        setTareas([]);
        setSelectedDate(dateFechaActual);
        setFechaInicioProyecto(dateFechaActual);
        setFechaFinProyecto(dateFechaActual);
        setConfirm(false);
        //
        limpiarComponentes();
    }

    const limpiarComponentes = () => {
        // Lunes
        setIdLunes("-1");
        setHorasLunes(0);
        setActividadesLunes("");
        setEstatusDateLunes("PENDIENTE")
        setObservacionesLunes("");
        setDiaAsuetoLunes(false);
        // Martes
        setIdMartes("-1");
        setHorasMartes(0);
        setActividadesMartes("");
        setEstatusDateMartes("PENDIENTE")
        setObservacionesMartes("");
        setDiaAsuetoMartes(false);
        // Miércoles
        setIdMiercoles("-1");
        setHorasMiercoles(0);
        setActividadesMiercoles("");
        setEstatusDateMiercoles("PENDIENTE")
        setObservacionesMiercoles("");
        setDiaAsuetoMiercoles(false);
        // Jueves
        setIdJueves("-1");
        setHorasJueves(0);
        setActividadesJueves("");
        setEstatusDateJueves("PENDIENTE")
        setObservacionesJueves("");
        setDiaAsuetoJueves(false);
        // Viernes
        setIdViernes("-1");
        setHorasViernes(0);
        setActividadesViernes("");
        setEstatusDateViernes("PENDIENTE")
        setObservacionesViernes("");
        setDiaAsuetoViernes(false);
        // Sábado
        setIdSabado("-1");
        setHorasSabado(0);
        setActividadesSabado("");
        setEstatusDateSabado("PENDIENTE")
        setObservacionesSabado("");
        setDiaAsuetoSabado(false);
        // Domingo
        setIdDomingo("-1");
        setHorasDomingo(0);
        setActividadesDomingo("");
        setEstatusDateDomingo("PENDIENTE")
        setObservacionesDomingo("");
        setDiaAsuetoDomingo(false);
    }

    const getWeekLabel = (date) => {
        const inicioSemana = startOfWeek(date, { weekStartsOn: 1 }); // semana empieza en lunes
        const finSemana = endOfWeek(date, { weekStartsOn: 1 });
        dateLunes = inicioSemana
        dateMartes = inicioSemana.addDays(1);
        dateMiercoles = inicioSemana.addDays(2);
        dateJueves = inicioSemana.addDays(3);
        dateViernes = inicioSemana.addDays(4);
        dateSabado = inicioSemana.addDays(5);
        dateDomingo = inicioSemana.addDays(6);
        return `Lunes ${format(inicioSemana, 'dd/MM/yyyy')} - Domingo ${format(dateDomingo, 'dd/MM/yyyy')}`;
    };

    const obtenerProyectos = () => {
        axios.post(`${apiUrl}/proyecto/obtenProyectosUsuario?token=${sessionStorage.getItem('token')}`, 
            {
                idUsuario: usuario.IDUSUARIO
            })
            .then((objResponse) => {
                setProyectos(objResponse.data.response)
            })
            .catch((error) => {
                alert('hubo un error: ' + error.response.data)
            });
    }

    const obtenDiasAsueto = (fechas) => {
        axios.post(`${apiUrl}/diasAsueto/obtenDiasAsueto?token=${sessionStorage.getItem('token')}`, 
            {
                arrFechas: fechas
            })
            .then((objResponse) => {
                setDiasAsueto(objResponse.data.result);
            })
            .catch((error) => {
                alert('hubo un error: ' + error.response.data)
            });
    }
    // Cargar datos iniciales
    useEffect(() => {
        obtenerProyectos();
    }, []);

    // 1.- useEffect para el cambio de idProyecto
    useEffect(() => {
        if(selectedProyecto != null && selectedProyecto != 0) {
            setSelectedEtapa(null);
            setEtapas([]);
            setSelectedTarea(null);
            setTareas([]);
            axios.post(`${apiUrl}/etapa/obtenEtapasProyecto?token=${sessionStorage.getItem('token')}`, {idProyecto: selectedProyecto})
                .then((objResponse) => {
                    setEtapas(objResponse.data.response)
                })
                .catch((error) => {
                    alert('hubo un error al recuperar etapas: ' + error.response.data)
                });
        }
    }, [selectedProyecto]);

    // 2.- useEffect para cambio de etapa
    useEffect(() => {
        if(selectedEtapa!=null) {
            setSelectedTarea(null);
            setTareas([]);
            axios.post(`${apiUrl}/tarea/obtenTareasEtapa?token=${sessionStorage.getItem('token')}`, {idEtapa: selectedEtapa})
                .then((objResponse) => {
                    setTareas(objResponse.data.response)
                })
                .catch((error) => {
                    alert('hubo un error al recuperar tareas: ' + error.response.data)
                });
        }
    }, [selectedEtapa])
    
    // 3.- useEffect cuando se selecciona una tarea
    useEffect(() => {
        if(selectedTarea!=null) {
            axios.post(`${apiUrl}/tarea/obtenTareasEtapa?token=${sessionStorage.getItem('token')}`, {idEtapa: selectedEtapa})
                .then((objResponse) => {
                    let modifiedArr = objResponse.data.response.map(function(element){
                        return {
                            value: element.IDTAREA,
                            label: element.DESCRIPCION
                        };
                    });
                    //setTareas(modifiedArr)
                })
                .catch((error) => {
                    alert('hubo un error al recuperar tareas: ' + error.response.data)
                });
            
            getWeekLabel(selectedDate);
            let tempFechas = {
                lunes: dateLunes,
                martes: dateMartes,
                miercoles: dateMiercoles,
                jueves: dateJueves,
                viernes: dateViernes,
                sabado: dateSabado,
                domingo: dateDomingo,
            }
            obtenHorasLaboradas(tempFechas);
        }
    }, [selectedTarea])

    const handleGuardarHoras = () => {
        if (selectedProyecto === undefined) {
            alert("Escoge un proyecto de la lista de proyectos")
            return;
        }
        if (selectedEtapa === undefined) {
            alert("Escoge una etapa de la lista de etapas")
            return;
        }
        if (selectedTarea === undefined) {
            alert("Escoge una tarea de la lista de tareas")
            return;
        }
        let totalHorasReportadas = parseInt(horasLunes)+parseInt(horasMartes)+parseInt(horasMiercoles)+parseInt(horasJueves)+parseInt(horasViernes)
        if(horasLunes>totalHorasPorDia || horasMartes>totalHorasPorDia || horasMiercoles>totalHorasPorDia || horasJueves>totalHorasPorDia || horasViernes>totalHorasPorDia) {
            alert(`Máxima cantidad de horas por día es  (${totalHorasPorDia})`)
            return;
        }
        if(totalHorasReportadas>totalHorasPorSemana)
        {
            alert(`El total horas reportadas (${totalHorasReportadas}) es mayor al total de horas permitidas por semana (${totalHorasPorSemana})`)
            return;
        }
        let arrHoras = {}
        // Lunes
        if(dateLunes <= dateFechaActual && (estatusDateLunes === 'PENDIENTE' || estatusDateLunes === 'RECHAZADA'))
        {
            arrHoras.lunes =
            {
                idHora: idLunes,
                fecha: dateLunes,
                horas: (horasLunes.length === 0) ? 0 : horasLunes,
                actividades: actividadesLunes
            };
        }
        // Martes
        if(dateMartes <= dateFechaActual && (estatusDateMartes === 'PENDIENTE' || estatusDateMartes === 'RECHAZADA'))
        {
            arrHoras.martes =
            {
                idHora: idMartes,
                fecha: dateMartes,
                horas: (horasMartes.length === 0) ? 0 : horasMartes,
                actividades: actividadesMartes
            }
        }
        // Miércoles
        if(dateMiercoles <= dateFechaActual && (estatusDateMiercoles === 'PENDIENTE' || estatusDateMiercoles === 'RECHAZADA'))
        {
            arrHoras.miercoles =
            {
                idHora: idMiercoles,
                fecha: dateMiercoles,
                horas: (horasMiercoles.length === 0) ? 0 : horasMiercoles,
                actividades: actividadesMiercoles
            }
        }
        // Jueves
        if(dateJueves <= dateFechaActual && (estatusDateJueves === 'PENDIENTE' || estatusDateJueves === 'RECHAZADA'))
        {
            arrHoras.jueves =
            {
                idHora: idJueves,
                fecha: dateJueves,
                horas: (horasJueves.length === 0) ? 0 : horasJueves,
                actividades: actividadesJueves
            }
        }
        // Viernes
        if(dateViernes <= dateFechaActual && (estatusDateViernes === 'PENDIENTE' || estatusDateViernes === 'RECHAZADA'))
        {
            arrHoras.viernes = 
            {
                idHora: idViernes,
                fecha: dateViernes,
                horas: (horasViernes.length === 0) ? 0 : horasViernes,
                actividades: actividadesViernes
            }
        }
        // Sábado
        if(dateSabado <= dateFechaActual && (estatusDateSabado === 'PENDIENTE' || estatusDateSabado === 'RECHAZADA'))
        {
            arrHoras.sabado = 
            {
                idHora: idSabado,
                fecha: dateSabado,
                horas: (horasSabado.length === 0) ? 0 : horasSabado,
                actividades: actividadesSabado
            }
        }
        // Domingo
        if(dateDomingo <= dateFechaActual && (estatusDateDomingo === 'PENDIENTE' || estatusDateDomingo === 'RECHAZADA'))
        {
            arrHoras.domingo = 
            {
                idHora: idDomingo,
                fecha: dateDomingo,
                horas: (horasDomingo.length === 0) ? 0 : horasDomingo,
                actividades: actividadesDomingo
            }
        }

        axios.post(`${apiUrl}/horaslaboradas/guardaHorasColaborador?token=${sessionStorage.getItem('token')}`, 
            {
                idTarea: selectedTarea,
                idUsuario: usuario.IDUSUARIO,
                nombreUsuario: usuario.NOMBREUSUARIO,
                idProyecto: selectedProyecto,
                arrFechas: arrHoras,
                nombreTarea: nombreTareaSelected,
                nombreProyecto: nombreProyectoSelected
            })
            .then((objResponse) => {
                limpiarFiltros();
            })
            .catch((error) => {
                alert('hubo un error al guardar las horas reportadas: ' + error.response.data)
            });
        //*/
    }
    //
    return (
        <Container>
            <Row style={textCenter}>
                <Col><h3>Registro de horas</h3></Col>
            </Row>
            <Row className="justify-content-md-center" >
                <Col md={8}>
                    <Table striped hover>
                        <tbody>
                            <tr>
                                <th>Nombre del colaborador:</th>
                                <td>{usuario.NOMBREUSUARIO}</td>
                            </tr>
                            <tr>
                                <th>Número usuario:</th>
                                <td>{usuario.IDUSUARIO}</td>
                            </tr>
                            <tr>
                                <th>Proyecto:</th>
                                <td>
                                <Form.Select onChange={(e) => {
                                    const selectedOption = e.target.selectedOptions[0];
                                    const fecha_inicio = selectedOption.dataset.fecha_inicio;
                                    const fecha_fin = selectedOption.dataset.fecha_fin;
                                    const horas_semana = selectedOption.dataset.horas_semana;
                                    const horas_dia = selectedOption.dataset.horas_dia;
                                    //*/
                                    setSelectedDate((new Date(fecha_fin).addDays(1) >= dateFechaActual) ? dateFechaActual : new Date(fecha_fin).addDays(1))
                                    setSelectedProyecto(e.target.value);
                                    setNombreProyectoSelected(e.target.options[e.target.selectedIndex].text);
                                    setTotalHorasPorSemana(horas_semana);
                                    setTotalHorasPorDia(horas_dia);
                                    setFechaInicioProyecto(new Date(fecha_inicio).addDays(1))
                                    setFechaFinProyecto((new Date(fecha_fin).addDays(1) >= dateFechaActual) ? dateFechaActual : new Date(fecha_fin).addDays(1))
                                    //*/
                                }}>
                                    <option key="opt_proyecto0" value={0}>Selecciona un proyecto</option>
                                    {
                                        proyectos.map(proyecto =>
                                            <option 
                                                key={'opt_proyecto'+proyecto.IDPROYECTO} 
                                                value={proyecto.IDPROYECTO} 
                                                data-fecha_inicio={proyecto.INICIO}
                                                data-fecha_fin={proyecto.FIN}
                                                data-horas_semana={proyecto.HORASSEMANA}
                                                data-horas_dia={proyecto.HORASDIA}
                                            >
                                                {proyecto.NOMBREPROYECTO}
                                            </option>
                                        )
                                    }
                                </Form.Select>
                                </td>
                            </tr>
                            <tr>
                                <th>Etapa:</th>
                                <td>
                                <Form.Select onChange={(e) => {
                                    setSelectedEtapa(e.target.value)
                                }}>
                                    <option key="opt_etapa0" value={0}>Selecciona una etapa</option>
                                    {
                                        etapas.map(etapa =>
                                            <option key={'opt_etapa'+etapa.IDETAPA} value={etapa.IDETAPA}>{etapa.DESCRIPCION}</option>
                                        )
                                    }
                                </Form.Select>
                                </td>
                            </tr>
                            <tr>
                                <th>Tarea:</th>
                                <td>
                                <Form.Select onChange={(e) => {
                                    setSelectedTarea(e.target.value)
                                    setNombreTareaSelected(e.target.options[e.target.selectedIndex].text);
                                }

                                }>
                                    <option key="opt_tarea0" value={0}>Selecciona una tarea</option>
                                    {
                                        tareas.map(tarea =>
                                            <option key={'opt_tarea'+tarea.IDTAREA} value={tarea.IDTAREA}>{tarea.DESCRIPCION}</option>
                                        )
                                    }
                                </Form.Select>
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    Semana que se está capturando:
                                    {selectedDate && (<div style={{ marginTop: '1em' }}><u>{getWeekLabel(selectedDate)}</u></div>)}
                                </th>
                                <td>
                                <DatePicker
                                    className='form-control'
                                    selected={selectedDate}
                                    onChange={handleChangeFecha}
                                    dateFormat="dd/MM/yyyy"
                                    showWeekNumbers
                                    calendarStartDay={1}
                                    highlightDates={[selectedDate]}
                                    minDate={fechaInicioProyecto}
                                    maxDate={fechaFinProyecto}
                                />
                                </td>
                            </tr>
                        </tbody>
                    </Table>
                </Col>
            </Row>
            <Row style={{marginTop: '1em', textAlign: 'center'}}>
                <Col md={2}></Col>
                <Col md={2}>
                    Lunes {format(dateLunes,'dd/MM/yyyy')} &nbsp;
                    {
                        (estatusDateLunes==='RECHAZADA') ? 
                        <OverlayTrigger
                            placement='top'
                            overlay={
                                <Tooltip>
                                    <strong>Observaciones: </strong><br/>
                                    {observacionesLunes}
                                </Tooltip>
                            }
                        >
                            <i
                                className="bi bi-exclamation-circle-fill" 
                                style={{marginRight: '1em', color:'red'}} 
                            >
                            </i>
                        </OverlayTrigger>
                        : 
                            (estatusDateLunes==='APROBADA') ? 
                                <i
                                    className="bi bi-check-circle-fill"
                                    style={{marginRight: '1em', color:'green'}} 
                                >
                                </i>
                            : 
                            (diaAsuetoLunes===true)  ? 
                            <OverlayTrigger
                                placement='top'
                                overlay={
                                    <Tooltip>
                                        <strong>Observaciones:  </strong><br/>
                                        Día asueto
                                    </Tooltip>
                                }
                            >
                                <i
                                    className="bi bi-exclamation-circle-fill" 
                                    style={{marginRight: '1em', color:'green'}} 
                                >
                                </i>
                            </OverlayTrigger>
                            : ''
                    }
                </Col>
                <Col md={2}>
                    Martes {format(dateMartes,'dd/MM/yyyy')} &nbsp;
                    {
                        (estatusDateMartes==='RECHAZADA') ? 
                        <OverlayTrigger
                            placement='top'
                            overlay={
                                <Tooltip>
                                    <strong>Observaciones: </strong><br/>
                                    {observacionesMartes}
                                </Tooltip>
                            }
                        >
                            <i
                                className="bi bi-exclamation-circle-fill" 
                                style={{marginRight: '1em', color:'red'}} 
                            >
                            </i>
                        </OverlayTrigger>
                        :
                            (estatusDateMartes==='APROBADA') ? 
                                <i
                                    className="bi bi-check-circle-fill"
                                    style={{marginRight: '1em', color:'green'}} 
                                >
                                </i>
                            :
                            (diaAsuetoMartes===true)  ? 
                            <OverlayTrigger
                                placement='top'
                                overlay={
                                    <Tooltip>
                                        <strong>Observaciones:  </strong><br/>
                                        Día asueto
                                    </Tooltip>
                                }
                            >
                                <i
                                    className="bi bi-exclamation-circle-fill" 
                                    style={{marginRight: '1em', color:'green'}} 
                                >
                                </i>
                            </OverlayTrigger>
                            : ''
                    }
                </Col>
                <Col md={2}>
                    Miércoles {format(dateMiercoles,'dd/MM/yyyy')} &nbsp;
                    {
                        (estatusDateMiercoles==='RECHAZADA') ? 
                        <OverlayTrigger
                            placement='top'
                            overlay={
                                <Tooltip>
                                    <strong>Observaciones: </strong><br/>
                                    {observacionesMiercoles}
                                </Tooltip>
                            }
                        >
                            <i
                                className="bi bi-exclamation-circle-fill" 
                                style={{marginRight: '1em', color:'red'}} 
                            >
                            </i>
                        </OverlayTrigger>
                        :
                            (estatusDateMiercoles==='APROBADA') ? 
                                <i
                                    className="bi bi-check-circle-fill"
                                    style={{marginRight: '1em', color:'green'}} 
                                >
                                </i>
                            :
                            (diaAsuetoMiercoles===true)  ? 
                            <OverlayTrigger
                                placement='top'
                                overlay={
                                    <Tooltip>
                                        <strong>Observaciones:  </strong><br/>
                                        Día asueto
                                    </Tooltip>
                                }
                            >
                                <i
                                    className="bi bi-exclamation-circle-fill" 
                                    style={{marginRight: '1em', color:'green'}} 
                                >
                                </i>
                            </OverlayTrigger>
                            : ''
                    }
                </Col>
                <Col md={2}>
                    Jueves {format(dateJueves,'dd/MM/yyyy')} &nbsp;
                    {
                        (estatusDateJueves==='RECHAZADA') ? 
                        <OverlayTrigger
                            placement='top'
                            overlay={
                                <Tooltip>
                                    <strong>Observaciones: </strong><br/>
                                    {observacionesJueves}
                                </Tooltip>
                            }
                        >
                            <i
                                className="bi bi-exclamation-circle-fill" 
                                style={{marginRight: '1em', color:'red'}} 
                            >
                            </i>
                        </OverlayTrigger>
                        :
                            (estatusDateJueves==='APROBADA') ? 
                                <i
                                    className="bi bi-check-circle-fill"
                                    style={{marginRight: '1em', color:'green'}} 
                                >
                                </i>
                            :
                            (diaAsuetoJueves===true)  ? 
                            <OverlayTrigger
                                placement='top'
                                overlay={
                                    <Tooltip>
                                        <strong>Observaciones:  </strong><br/>
                                        Día asueto
                                    </Tooltip>
                                }
                            >
                                <i
                                    className="bi bi-exclamation-circle-fill" 
                                    style={{marginRight: '1em', color:'green'}} 
                                >
                                </i>
                            </OverlayTrigger>
                            : ''
                    }
                </Col>
                
            </Row>
            <Row>
                <Col md={2}></Col>
                <Col md={2}>
                    <Form.Control 
                        type="number" 
                        value={horasLunes}
                        onKeyDown={(event) => {validacionInput(event)}} 
                        onChange={(event)=>{handleChangeHoras(event.target.value, 'lunes'); }}
                        placeholder="Horas Lunes"
                        disabled={ (dateLunes > dateFechaActual || estatusDateLunes==='APROBADA' || diaAsuetoLunes) ? true : false }
                        style={{ borderColor: (estatusDateLunes==='RECHAZADA') ? 'red' : '' }}
                    />
                    <Form.Control as="textarea" rows={3} placeholder='Descripción de actividades' 
                        onChange={(event)=>{setActividadesLunes(event.target.value)}} value={actividadesLunes}
                        disabled={ (dateLunes > dateFechaActual || estatusDateLunes==='APROBADA' || diaAsuetoLunes) ? true : false }
                        style={{marginTop: '1em', borderColor: (estatusDateLunes==='RECHAZADA') ? 'red' : '' }}
                    />
                </Col>
                <Col md={2}>
                    <Form.Control 
                        type="number" 
                        value={horasMartes}
                        onKeyDown={(event) => {validacionInput(event)}} 
                        onChange={(event)=>{handleChangeHoras(event.target.value, 'martes'); }}
                        placeholder="Horas Martes"
                        disabled={ (dateMartes > dateFechaActual || estatusDateMartes==='APROBADA' || diaAsuetoMartes) ? true : false }
                        style={{ borderColor: (estatusDateMartes==='RECHAZADA') ? 'red' : '' }}
                    />
                    <Form.Control as="textarea" rows={3} placeholder='Descripción de actividades' 
                        onChange={(event)=>{setActividadesMartes(event.target.value)}} value={actividadesMartes}
                        disabled={ (dateMartes > dateFechaActual || estatusDateMartes==='APROBADA' || diaAsuetoMartes) ? true : false }
                        style={{ marginTop: '1em', borderColor: (estatusDateMartes==='RECHAZADA') ? 'red' : '' }}
                    />
                </Col>
                <Col md={2}>
                    <Form.Control 
                        type="number" 
                        value={horasMiercoles}
                        onKeyDown={(event) => {validacionInput(event)}} 
                        onChange={(event)=>{handleChangeHoras(event.target.value, 'miercoles'); }}
                        placeholder="Horas Miércoles"
                        disabled={ (dateMiercoles > dateFechaActual || estatusDateMiercoles==='APROBADA' || diaAsuetoMiercoles) ? true : false }
                        style={{ borderColor: (estatusDateMiercoles==='RECHAZADA') ? 'red' : '' }}
                    />
                    <Form.Control as="textarea" rows={3} placeholder='Descripción de actividades' 
                        onChange={(event)=>{setActividadesMiercoles(event.target.value)}} value={actividadesMiercoles}
                        disabled={ (dateMiercoles > dateFechaActual || estatusDateMiercoles==='APROBADA' || diaAsuetoMiercoles) ? true : false }
                        style={{ marginTop: '1em', borderColor: (estatusDateMiercoles==='RECHAZADA') ? 'red' : '' }}
                    />
                </Col>
                <Col md={2}>
                    <Form.Control 
                        type="number" 
                        value={horasJueves}
                        onKeyDown={(event) => {validacionInput(event)}} 
                        onChange={(event)=>{handleChangeHoras(event.target.value, 'jueves'); }}
                        placeholder="Horas Jueves"
                        disabled={ (dateJueves > dateFechaActual || estatusDateJueves==='APROBADA' || diaAsuetoJueves) ? true : false }
                        style={{ borderColor: (estatusDateJueves==='RECHAZADA') ? 'red' : '' }}
                    />
                    <Form.Control as="textarea" rows={3} placeholder='Descripción de actividades' 
                        onChange={(event)=>{setActividadesJueves(event.target.value)}} value={actividadesJueves}
                        disabled={ (dateJueves > dateFechaActual || estatusDateJueves==='APROBADA' || diaAsuetoJueves) ? true : false }
                        style={{ marginTop: '1em', borderColor: (estatusDateJueves==='RECHAZADA') ? 'red' : '' }}
                    />
                </Col>
            </Row>
            
            <Row style={{paddingTop: '1em', textAlign: 'center'}}>
                <Col md={2}></Col>
                <Col md={2}>
                    Viernes {format(dateViernes,'dd/MM/yyyy')} &nbsp;
                    {
                        (estatusDateViernes==='RECHAZADA') ? 
                        <OverlayTrigger
                            placement='top'
                            overlay={
                                <Tooltip>
                                    <strong>Observaciones: </strong><br/>
                                    {observacionesViernes}
                                </Tooltip>
                            }
                        >
                            <i
                                className="bi bi-exclamation-circle-fill" 
                                style={{marginRight: '1em', color:'red'}} 
                            >
                            </i>
                        </OverlayTrigger>
                        :
                            (estatusDateViernes==='APROBADA') ? 
                                <i
                                    className="bi bi-check-circle-fill"
                                    style={{marginRight: '1em', color:'green'}} 
                                >
                                </i>
                            :
                            (diaAsuetoViernes===true)  ? 
                            <OverlayTrigger
                                placement='top'
                                overlay={
                                    <Tooltip>
                                        <strong>Observaciones:  </strong><br/>
                                        Día asueto
                                    </Tooltip>
                                }
                            >
                                <i
                                    className="bi bi-exclamation-circle-fill" 
                                    style={{marginRight: '1em', color:'green'}} 
                                >
                                </i>
                            </OverlayTrigger>
                            : ''
                    }
                </Col>
                <Col md={2}>
                    Sábado {format(dateSabado,'dd/MM/yyyy')} &nbsp;
                    {
                        (estatusDateSabado==='RECHAZADA') ? 
                        <OverlayTrigger
                            placement='top'
                            overlay={
                                <Tooltip>
                                    <strong>Observaciones: </strong><br/>
                                    {observacionesSabado}
                                </Tooltip>
                            }
                        >
                            <i
                                className="bi bi-exclamation-circle-fill" 
                                style={{marginRight: '1em', color:'red'}} 
                            >
                            </i>
                        </OverlayTrigger>
                        :
                            (estatusDateSabado==='APROBADA') ? 
                                <i
                                    className="bi bi-check-circle-fill"
                                    style={{marginRight: '1em', color:'green'}} 
                                >
                                </i>
                            :
                            (diaAsuetoSabado===true)  ? 
                            <OverlayTrigger
                                placement='top'
                                overlay={
                                    <Tooltip>
                                        <strong>Observaciones:  </strong><br/>
                                        Día asueto
                                    </Tooltip>
                                }
                            >
                                <i
                                    className="bi bi-exclamation-circle-fill" 
                                    style={{marginRight: '1em', color:'green'}} 
                                >
                                </i>
                            </OverlayTrigger>
                            : ''
                    }
                </Col>
                <Col md={2}>
                    Domingo {format(dateDomingo,'dd/MM/yyyy')} &nbsp;
                    {
                        (estatusDateDomingo==='RECHAZADA') ? 
                        <OverlayTrigger
                            placement='top'
                            overlay={
                                <Tooltip>
                                    <strong>Observaciones: </strong><br/>
                                    {observacionesDomingo}
                                </Tooltip>
                            }
                        >
                            <i
                                className="bi bi-exclamation-circle-fill" 
                                style={{marginRight: '1em', color:'red'}} 
                            >
                            </i>
                        </OverlayTrigger>
                        :
                            (estatusDateDomingo==='APROBADA') ? 
                                <i
                                    className="bi bi-check-circle-fill"
                                    style={{marginRight: '1em', color:'green'}} 
                                >
                                </i>
                            :
                            (diaAsuetoDomingo===true)  ? 
                            <OverlayTrigger
                                placement='top'
                                overlay={
                                    <Tooltip>
                                        <strong>Observaciones:  </strong><br/>
                                        Día asueto
                                    </Tooltip>
                                }
                            >
                                <i
                                    className="bi bi-exclamation-circle-fill" 
                                    style={{marginRight: '1em', color:'green'}} 
                                >
                                </i>
                            </OverlayTrigger>
                            : ''
                    }
                </Col>
            </Row>
            <Row>
                <Col md={2}></Col>
                <Col md={2}>
                    <Form.Control 
                        type="number"
                        value={horasViernes}
                        onKeyDown={(event) => {validacionInput(event)}} 
                        onChange={(event)=>{handleChangeHoras(event.target.value, 'viernes'); }}
                        placeholder="Horas Viernes"
                        disabled={ (dateViernes > dateFechaActual || estatusDateViernes==='APROBADA' || diaAsuetoViernes) ? true : false }
                        style={{ borderColor: (estatusDateViernes==='RECHAZADA') ? 'red' : '' }}
                    />
                    <Form.Control as="textarea" rows={3} placeholder='Descripción de actividades' 
                        onChange={(event)=>{setActividadesViernes(event.target.value)}} value={actividadesViernes}
                        disabled={ (dateViernes > dateFechaActual || estatusDateViernes==='APROBADA' || diaAsuetoViernes) ? true : false }
                        style={{ marginTop: '1em', borderColor: (estatusDateViernes==='RECHAZADA') ? 'red' : '' }}
                    />
                </Col>
                <Col md={2}>
                    <Form.Control 
                        type="number"
                        value={horasSabado}
                        onKeyDown={(event) => {validacionInput(event)}} 
                        onChange={(event)=>{handleChangeHoras(event.target.value, 'sabado'); }}
                        placeholder="Horas Sábado"
                        disabled={ (dateSabado > dateFechaActual || estatusDateSabado==='APROBADA' || diaAsuetoSabado) ? true : false }
                        style={{ borderColor: (estatusDateSabado==='RECHAZADA') ? 'red' : '' }}
                    />
                    <Form.Control as="textarea" rows={3} placeholder='Descripción de actividades' 
                        onChange={(event)=>{setActividadesSabado(event.target.value)}} value={actividadesSabado}
                        disabled={ (dateSabado > dateFechaActual || estatusDateSabado==='APROBADA' || diaAsuetoSabado) ? true : false }
                        style={{ marginTop: '1em', borderColor: (estatusDateSabado==='RECHAZADA') ? 'red' : '' }}
                    />
                </Col>
                <Col md={2}>
                    <Form.Control 
                        type="number"
                        value={horasDomingo}
                        onKeyDown={(event) => {validacionInput(event)}} 
                        onChange={(event)=>{handleChangeHoras(event.target.value, 'domingo'); }}
                        placeholder="Horas Domingo"
                        disabled={ (dateDomingo > dateFechaActual || estatusDateDomingo==='APROBADA' || diaAsuetoDomingo) ? true : false }
                        style={{ borderColor: (estatusDateDomingo==='RECHAZADA') ? 'red' : '' }}
                    />
                    <Form.Control as="textarea" rows={3} placeholder='Descripción de actividades' 
                        onChange={(event)=>{setActividadesDomingo(event.target.value)}} value={actividadesDomingo}
                        disabled={ (dateDomingo > dateFechaActual || estatusDateDomingo==='APROBADA' || diaAsuetoDomingo) ? true : false }
                        style={{ marginTop: '1em', borderColor: (estatusDateDomingo==='RECHAZADA') ? 'red' : '' }}
                    />
                </Col>
            </Row>

            <Row style={{marginTop: '1em'}}>
                <Col md={3}>
                </Col>
                <Col>
                    <Form.Group controlId="formBasicCheckbox">
                        <Form.Check 
                            type="checkbox" 
                            label="Confirmo que estoy declarando las horas trabajadas para el proyecto, etapa y tareas indicados." 
                            checked={confirm}
                            onChange={(event)=>{ setConfirm(event.target.checked) }}
                        />
                    </Form.Group>
                </Col>
            </Row>
            <Row style={{marginTop: '1em'}}>
                <Col md={5}>
                </Col>
                <Col>
                    <Button 
                        disabled={!confirm}
                        onClick={handleGuardarHoras}
                        style={{marginBottom: '1em'}}
                    >
                        Guardar
                    </Button>
                    <div>
                        
                    </div>
                </Col>
            </Row>
        </Container>
    )
}

export default RegistroHoras;